"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * Enables a seller adding an ad or item on a Partner's site to automatically create an eBay listing draft using the item details from the Partner's site.
 */
class Listing extends __1.default {
    get basePath() {
        return '/sell/listing/v1_beta';
    }
    /**
     * This call gives Partners the ability to create an eBay draft of a item for their seller using information from their site.
     *
     * @param data The ItemDraft
     */
    createItemDraft(data) {
        return this.post(`/item_draft/`, data);
    }
}
exports.default = Listing;
Listing.id = 'Listing';
//# sourceMappingURL=index.js.map